export class DeclinedReasonQueryParameters {
  id?: string;
  includeOnServiceNoticeFlag?: boolean;
  moveToQuoteHistoryFlag?: boolean;
  reason?: string;
  rooftopId?: string;

  constructor(obj?: DeclinedReasonQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
